import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Modal } from '.';
import { IThemeProps } from '../assets/theme';

interface IProgressBarProps extends IThemeProps {
  progress: number;
}

interface IRunningInvoiceComparisonModalProps {
  onComplete: () => void;
  onCancel: () => void;
  isOpen: boolean;
}

const ProgressContainer = styled.div`
  text-align: center;
  padding: 30px 20px;
`;

const Subtitle = styled.p`
  font-size: 1em;
  margin-bottom: 30px;
  color: #666;
  line-height: 1.4;
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 16px;
  background-color: #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
  max-width: 280px;
`;

const ProgressBarFill = styled.div<IProgressBarProps>`
  height: 100%;
  background-color: #ff6600;
  border-radius: 10px;
  transition: width 0.3s ease;
  width: ${({ progress }) => progress}%;
`;

const RunningInvoiceComparisonModal: React.FC<IRunningInvoiceComparisonModalProps> = ({ onComplete, onCancel, isOpen }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!isOpen) {
      setProgress(0);
      return undefined;
    }

    // TODO - implement progress indicator with API if required, this is a placeholder
    const interval = setInterval(() => {
      setProgress(prev => {
        const newProgress = prev + 2; // Increase by 2% every 100ms (5 seconds total)
        if (newProgress >= 100) {
          clearInterval(interval);
          // Wait a bit to show 100% completion before closing
          setTimeout(() => {
            onComplete();
          }, 500);
          return 100;
        }
        return newProgress;
      });
    }, 100);

    return () => clearInterval(interval);
  }, [isOpen, onComplete]);

  return (
    <Modal
      isOpen={isOpen}
      options={{
        title: 'Hang Tight!',
        noBackdrop: true, // Prevent dismissing the modal
      }}
      onDecline={onCancel}
      onConfirm={() => {}} // Cannot confirm while processing
      preloader={false}
    >
      <Modal.Body>
        <ProgressContainer>
          <Subtitle>
            OTTO is comparing internal invoice<br />
            data to Vendor Data
          </Subtitle>
          <ProgressBarContainer>
            <ProgressBarFill progress={progress} />
          </ProgressBarContainer>
        </ProgressContainer>
      </Modal.Body>
    </Modal>
  );
};

export default RunningInvoiceComparisonModal;
